import Vue from 'vue';
import Element from 'element-ui';
import locale from 'element-ui/lib/locale/lang/en';  // Import English locale
import 'element-ui/lib/theme-chalk/index.css';
import 'element-ui/lib/theme-chalk/display.css';

// Set Element UI locale to English
Vue.use(Element, { locale });  // Pass the English locale to Vue.use
